export default __webpack_public_path__ + "bdeb086f990f0bb1aa750649dee2b680.png";